import { render, staticRenderFns } from "./ForfeitedAmountReport.vue?vue&type=template&id=244fa996&"
import script from "./ForfeitedAmountReport.vue?vue&type=script&lang=js&"
export * from "./ForfeitedAmountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports